import { IconButton, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/HighlightOff';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, change, reduxForm } from 'redux-form';
import { BLUE, GREEN, ORANGE, PERMISSIONS, PERMISSION_ENTITIES, VISIBLE_TAGS_NUMBER } from '../../_config/consts';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import * as TagActions from '../../redux/actions/tag.actions';
import ArrowLeftIconCustom from '../CustomIcons/ArrowLeftIconCustom.jsx';
import TagIconCustom from '../CustomIcons/TagIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import Tag from '../Tag.jsx';
import TagsSelectorField from '../forms/Fields/TagsSelectorField.jsx';
import TagRemoveIconCustom from '../CustomIcons/TagRemoveIconCustom.jsx';
import { WarningOutlined } from '@material-ui/icons';

const validate = values => {
  const errors = {};
  
  if (!values||!values.tags||!values.tags.length) {
    errors.tags = 'required';
  }

  return errors;
};

const styles = theme => ({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
  },
  titleText: {
    marginRight: 5,
    marginBottom: 5,
    fontSize: 20,
    fontWeight: 'bold',
    color: '#3f3f3f',
    textAlign: 'left',
  },
  sectionText: {
    margin: 0,
    marginRight: 5,
    fontSize: 18,
    lineHeight: 1.4,
    color: '#878787',
    textAlign: 'left',
  },
  exampleContainer: {
    marginTop: 15,
    borderRadius: 5,
  },
  exampleText: {
    marginLeft: 12,
    marginTop: 10,
    fontSize: 15,
    color: '#3f3f3f',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  warningTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    marginTop: -20,
  },
  guestCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  guestDataText: {
    fontWeight: 'bold',
    margin: 0,
    color: '#3f3f3f',
    marginTop: 2,
  },
});

const LockRow = ({ item, isEaven }) => {
  const fakeLockTag = {
    color: '#ba68c8',
    name: item && item.name ? item.name.toLowerCase() : '',
    type: 'lock',
  };
  const backgroundColor = !isEaven ? '#FAFAFA' : 'white';
  const visibleTags = _.slice(item.tags, 0, VISIBLE_TAGS_NUMBER);
  return (
    <div
      className="card-noHover tag-element-selected"
      style={{ display: 'flex', zIndex: 0, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', margin: 5, marginBottom: 0, marginTop: 0, backgroundColor }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h5 style={{ margin: 0, color: '#3f3f3f' }}>{item.name}{item.serialNumber ? <h6 style={{ margin: 0, marginTop: 2, color: '#3f3f3f' }}>{item.serialNumber}</h6> : null}</h5>
      </div>
      <div className="tags-container" style={{ margin: 0, marginLeft: 55 }}>
        {item && item.name &&
          <Tag textStyle={{ fontSize: 12 }} style={{ paddingTop: 4, paddingBottom: 4 }} tag={fakeLockTag} />
        }
        {_.map(visibleTags, tag =>
          <Tag
            key={tag.id}
            tag={tag}
            style={{ padding: 5 }}
            textStyle={{ fontSize: 14 }}
          />,
        )}
      </div>
    </div>
  );
};

@reduxForm({ form: 'LockBatchTagsForm', validate })
@connect(state => ({ form: state.form.LockBatchTagsForm, lockTags: state.tags.lock, companyConfigurations: state.user.companyConfigurations }))
class LocksTagsBatchView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
    }
  }

  onFilterLockTags(value) {
    const { dispatch } = this.props;
    dispatch(TagActions.cancelFetchLockTagsByFilter());
    dispatch(TagActions.fetchLockTagsByFilter(value, 50));
  }

  onConfirm() {
    const { onAddTagsLocksBatchConfirm, onRemoveTagsLocksBatchConfirm, form, locks, removeMode } = this.props;
    const tagsAdd = form&&form.values&&form.values.tags
    const tagsRemove = form&&form.values&&form.values.deletingTags
    if (removeMode&&(!tagsRemove||!tagsRemove.length))
      return;
    if (!removeMode&&(!tagsAdd||!tagsAdd.length))
      return;
    if (removeMode)
      onRemoveTagsLocksBatchConfirm(tagsRemove)
    else
      onAddTagsLocksBatchConfirm(tagsAdd)
  }

  async onAddToRemovable(item) {
    const { form, dispatch } = this.props;
    const { } = this.state;
    const removableTags = form&&form.values&&form.values.removableTags?form.values.removableTags:[]
    const deletingTags = form&&form.values&&form.values.deletingTags?form.values.deletingTags:[]
    await dispatch(change('LockBatchTagsForm', 'removableTags', [...removableTags,item]));
    await dispatch(change('LockBatchTagsForm', 'deletingTags', _.filter(deletingTags, i => i.id !== item.id)));
  }

  async onAddToDeleting(item) {
    const { form, dispatch } = this.props;
    const { } = this.state;
    const removableTags = form&&form.values&&form.values.removableTags?form.values.removableTags:[]
    const deletingTags = form&&form.values&&form.values.deletingTags?form.values.deletingTags:[]
    await dispatch(change('LockBatchTagsForm', 'removableTags', _.filter(removableTags, i => i.id !== item.id)));
    await dispatch(change('LockBatchTagsForm', 'deletingTags', [...deletingTags,item]));
  }

  render() { 
    const { 
      classes, locks, lockTags, form, 
      formStyle,
      removeMode,
    } = this.props;

    const availableTags = lockTags.data

    const uniqueLocks = _.uniqBy(locks, 'id')

    const removableTags = form&&form.values&&form.values.removableTags?form.values.removableTags:[]
    const deletingTags = form&&form.values&&form.values.deletingTags?form.values.deletingTags:[]
    
    const canEditLock = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.UPDATE], PERMISSION_ENTITIES.SMART_LOCK);

    return (
      <div style={{ marginLeft: 13, marginBottom: 30, padding: 10 }}>
        <div className={classes.warningTitleContainer}>
          <h2 className={classes.titleText} style={{ margin: 0, marginLeft: 10, fontSize: 25 }}><Entity entity={removeMode?"locksRemoveTagsBatchTitle":"locksAddTagsBatchTitle"} /></h2>
        </div>
        <div className={classes.guestCardContainer}>
          <h2 className={classes.sectionText} style={{ color: '#3f3f3f', fontWeight: 'bold', fontSize: 20 }}><Entity entity={removeMode?"locksBatchToRemoveTags":"locksBatchToAddTags"} data={{ number: _.size(uniqueLocks) }} /></h2>
        </div>
        <div style={{ padding: 5, backgroundColor: '#f1f1f1', borderRadius: 10, marginTop: 20 }}>
          <div style={{ maxHeight: 200, overflowY: 'scroll' }}>
            <div style={{ paddingTop: 5, paddingBottom: 5 }}>
              {_.map(uniqueLocks, (item, index) =>
                <LockRow
                  item={item}
                  isEaven={index % 2 === 0}
                />,
              )}
            </div>
          </div>
        </div>
        {!removeMode ? <h2 className={classes.sectionText} style={{ marginTop: 25, marginBottom: 10, color:'#3f3f3f' }}><Entity entity="locksAddTagsBatchDescription" /></h2> : null}
        <Form style={formStyle} autoComplete="off">
          {!removeMode?(
            <Entity
              componentClass={Field}
              multi
              name="tags"
              componentAttribute="placeholder"
              entity="insertLocksTags"
              disabled
              component={TagsSelectorField}
              tagType="LOCK"
              tags={availableTags}
              isDisabled={!canEditLock}
              onNewTag={null}
              onEditTag={null}
              onInputChange={(value)=>this.onFilterLockTags(value)}
              containerStyle={{ width: '100%', margin: 0 }}
            />
          ):(
            <div style={{display: 'flex', flexDirection: 'row', marginTop: 30 }}>
              <div style={{display: 'flex', flexDirection: 'column', width: '50%', marginRight: 10 }}>
                <div style={{display: 'flex',flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                  <TagIconCustom style={{ width: 26, marginRight: 15, color: BLUE, marginLeft: 2 }}/>
                  <h4 style={{ marginTop: 0, color: '#3f3f3f', marginBottom: 0, fontWeight: 'bold' }}><Entity entity={"locksRemoveTagsBatchAvailable"} /></h4>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', borderRadius: 5, backgroundColor:'rgb(241, 241, 241)', maxHeight: 200, minHeight: 40, overflowY: 'auto', padding: 10 }}>
                  {_.map(removableTags, tag =>
                    <div style={{ display: 'flex', alignItems: 'center', margin: 10, width: 'fit-content', border: '1px solid #CCC', borderRadius: 4, backgroundColor: 'white', cursor: 'pointer' }} key={tag.id} onClick={()=> this.onAddToDeleting(tag)}>
                      <CloseIcon 
                        style={{ fontSize: 20, margin: 5, marginRight: 0, cursor:'pointer', color: 'indianred' }} 
                        onClick={()=> this.onAddToDeleting(tag)}
                      />
                      <Tag
                        key={tag.id}
                        tag={tag}
                        style={{ padding: 5, marginTop:1, marginRight:2 }}
                        textStyle={{ fontSize: 14 }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '50%', marginRight: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                  <TagRemoveIconCustom style={{ width: 20, marginRight: 10, color: 'indianred', marginLeft: 2 }} />
                  <h4 style={{ marginTop: 0, color: '#3f3f3f', marginBottom: 0, fontWeight: 'bold' }}><Entity entity={"locksRemoveTagsBatchRemoving"} /></h4>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', borderRadius: 5, backgroundColor: 'rgb(241, 241, 241)', maxHeight: 200, minHeight: 40, overflowY: 'auto', padding: 10, marginTop: 5 }}>
                  {_.map(deletingTags, tag =>
                    <div style={{ display: 'flex', alignItems: 'center', margin: 10, width: 'fit-content', border: '1px solid #DDD', borderRadius: 4, cursor: 'pointer', backgroundColor: 'white' }} key={tag.id} onClick={()=> this.onAddToRemovable(tag)}>
                      <IconButton onClick={()=> this.onAddToRemovable(tag) } style={{ padding:0 }}>
                        <ArrowLeftIconCustom style={{ color: 'grey', width: 20, margin: 5, marginRight: 0, cursor:'pointer' }} />
                      </IconButton>
                      <Tag
                        key={tag.id}
                        tag={tag}
                        style={{ padding: 5, marginTop:1, marginRight:2 }}
                        textStyle={{ fontSize: 14 }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Form>
        {removeMode ? (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 25 }}>
            <WarningOutlined style={{ color: ORANGE, fontSize: 20, marginRight: 10 }} />
            <h2 className={classes.sectionText} style={{ color:'gray' }}>
              <Entity entity={"locksRemoveTagsBatchNote"} />
            </h2>
          </div>
        ) : null}
        <MDButton
          title={<Entity entity="confirmAddTagsBatch" />}
          style={{
            marginTop:10,
            opacity:(removeMode && !(deletingTags.length))|| 
              (!removeMode && !(form&&form.values&&form.values.tags&&form.values.tags.length))?0.5:1
          }}
          backgroundColor={GREEN}
          disabled={
            (removeMode && !(deletingTags.length)) 
            || 
            (!removeMode && !(form&&form.values&&form.values.tags&&form.values.tags.length))
          }
          onClick={() => this.onConfirm()}
        />
      </div>
    );
  }
}
export default withStyles(styles)(LocksTagsBatchView);
